<template>
  <div class="embed">
    <AssetPresenter :content_asset="contentAsset" />
  </div>
</template>
<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { fetchPublicContentAsset } from '@app/api.js'
import AssetPresenter from '@survey/components/AssetPresenter.vue'

const props = defineProps({
  identifier: {
    type: String,
    required: true,
  },
})

const contentAsset = ref(null)

onMounted(async () => {
  await fetchPublicContentAsset(props.identifier).then((response: unknown) => {
    contentAsset.value = response.data.content_asset
  })
})
</script>
